import { styled, css } from "styled-components";

export const BlockContainer = styled.div`
  width: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid ${(props) => props.theme.colors.default[100]};
  font-size: 14px;
  overflow: hidden;
`;

export const BlockTitle = styled.h4`
  padding: 16px;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.default.default};
`;

export const BlockTableHeaderContainer = styled.thead`
  background: ${(props) => props.theme.colors.default.default};
`;

export const BlockTableBodyContainer = styled.tbody``;

export const BlockTable = styled.table`
  text-align: left;
  width: 100%;
`;

export const BlockTableRow = styled.tr`
  padding: 12px 24px;
  display: grid;
  grid-template-columns: minmax(0, 45%) minmax(0, 35%) minmax(0, 20%);

  &:not(:first-of-type) {
    border-top: 1px solid ${(props) => props.theme.colors.default[100]};
  }
`;

export const BlockTableHeader = styled.th`
  color: #9ea0aa;
  font-size: 12px;
  line-height: 14px;
  font-weight: 600;

  &:last-of-type {
    text-align: right;
  }
`;

export const BlockTableCell = styled.td`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  overflow-y: clip;
  overflow-x: auto;

  &:last-of-type {
    text-align: right;
    justify-content: end;
  }

  &[data-is-required="true"] {
    span svg path {
      fill: ${(props) => props.theme.colors.primary};
      stroke: ${(props) => props.theme.colors.primary};
    }
  }
  &[data-is-required="false"] {
    span {
      opacity: 0.2;
    }
  }
`;

export const CodeBlockContainer = styled(BlockContainer)`
    border-color: transparent;
    background: ${(props) => props.theme.colors.default[200]};
    overflow: hidden;

    & > div {
        font-size: 14px;
        width: 100% !important;
        border-radius: 0;
        padding-left: 10px;
    }

    code {
        font-family: monospace !important;

        &:first-of-type {
            color: #7b7b7b;
        }

        .boolean {
            color: #55a72f;
        }
    }
`;

interface CodeBlockTitleProps {
  type: "info" | "success" | "redirect" | "error";
}

export const CodeBlockTitle = styled(BlockTitle)<CodeBlockTitleProps>`
  ${(props) => {
  switch (props.type) {
    case "info":
      return css`
          color: #027ffe;
        `;
    case "success":
      return css`
          color: #80cd42;
        `;
    case "redirect":
      return css`
          color: ${({ theme }) => theme.colors.primary[500]};
        `;
    case "error":
      return css`
          color: ${({ theme }) => theme.colors.primary[600]};
        `;
  }
}};
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255);
  background: ${({ theme, type }) =>
  type === undefined ? theme.colors.default[50] : theme.colors.default[900]};
`;

export const CodeBlockDescription = styled.p`
  padding: 16px;
  border-bottom: 1px solid ${(props) => props.theme.colors.default.default};
`;

export const copyBlockTheme = {
  lineNumberColor: "#7B7B7B",
  lineNumberBgColor: "transparent",
  backgroundColor: "#423f3d",
  textColor: "#D2D2D2",
  subStringColor: "#D26971",
  keywordColor: "#D26971",
  attributeColor: "#D26971",
  selectorTagColor: "#D26971",
  docTagColor: "#D26971",
  nameColor: "#D26971",
  builtInColor: "#D26971",
  literalColor: "#D26971",
  bulletColor: "#D26971",
  codeColor: "#D26971",
  additionColor: "#D26971",
  regexpColor: "#D26971",
  symbolColor: "#D26971",
  variableColor: "#D26971",
  templateVariableColor: "#D26971",
  linkColor: "#D26971",
  selectorAttributeColor: "#D26971",
  selectorPseudoColor: "#D26971",
  typeColor: "#D26971",
  stringColor: "#D26971",
  selectorIdColor: "#D26971",
  selectorClassColor: "#D26971",
  quoteColor: "#D26971",
  templateTagColor: "#D26971",
  deletionColor: "#D26971",
  titleColor: "#D26971",
  sectionColor: "#D26971",
  commentColor: `rgba(150,150,150,0.8)`,
  metaKeywordColor: "#D26971",
  metaColor: "#D26971",
  functionColor: "#D26971",
  numberColor: "#75B7D0",
};

export const copyBlockThemeLight = {
  lineNumberColor: "#7B7B7B",
  lineNumberBgColor: "transparent",
  backgroundColor: "#F6F5F5",
  textColor: (props) => props.theme.colors.default.default,
  subStringColor: "#D21917",
  keywordColor: "#D21917",
  attributeColor: "#D21917",
  selectorTagColor: "#D21917",
  docTagColor: "#D21917",
  nameColor: "#D21917",
  builtInColor: "#D21917",
  literalColor: "#D21917",
  bulletColor: "#D21917",
  codeColor: "#D21917",
  additionColor: "#D21917",
  regexpColor: "#D21917",
  symbolColor: "#D21917",
  variableColor: "#D21917",
  templateVariableColor: "#D21917",
  linkColor: "#D21917",
  selectorAttributeColor: "#D21917",
  selectorPseudoColor: "#D21917",
  typeColor: "#D21917",
  stringColor: "#D21917",
  selectorIdColor: "#D21917",
  selectorClassColor: "#D21917",
  quoteColor: "#D21917",
  templateTagColor: "#D21917",
  deletionColor: "#D21917",
  titleColor: "#D21917",
  sectionColor: "#D21917",
  commentColor: (props) => props.theme.colors.default.default,
  metaKeywordColor: "#D21917",
  metaColor: "#D21917",
  functionColor: "#D21917",
  numberColor: "#2683A7",
};
